/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useEffect, useRef,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { distributorService } from '../../../service/distributor.service';
import { createUrl } from '../../../redux/helper/CreateQuery';

function FilterModal({
    filterModal, setFilterModal, Filter, setFilter, filterValue, setfilterValue, handleFilter, threeplList, setThreeplList, handleFetchInvoices, selected, setselected, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const orderTypes = ['Trade', 'Trade EUB', 'Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'];
    const [selectedType, setselectedType] = useState('order_category');
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);
    const [searchValue, serSearchValue] = useState('');
    const [searchDropdown, setSearchDropdown] = useState(false);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_category':
                if (Filter[key].length > 0) {
                    final += `&CATEGORY=${createUrl(Filter[key])}`;
                }
                break;
            case 'payment_status':
                if (Filter[key].length > 0) {
                    final += `&PAYMENT_STATUS=${createUrl(Filter[key])}`;
                }
                break;
            case 'plant_name':
                if (Filter[key].length > 0) {
                    final += `&PLANT_ID=${createUrl(Filter[key])}`;
                }
                break;
            case 'customer_code':
                if (Filter[key].length > 0) {
                    final += `&distributor_ids=${createUrl(Filter[key])}`;
                }
                break;

            default: break;
            }
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&TRX_DATE=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_category: [],
            payment_status: [],
            date_range: [],
            plant_name: [],
            customer_code: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        handleFetchInvoices();
        setFilterModal(false);
        SetSuccessMessage('Filters cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const onChangeSearch = (value) => {
        serSearchValue(value);
        distributorService.DistributorList(1, value, '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    };

    useEffect(() => {
        distributorService.DistributorList(1, '', '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    }, []);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[570px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={() => setselectedType('order_category')}>
                                    <a
                                        href="#pills-pricetab"
                                        className={`nav-link block text-base ${selectedType === 'order_category' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                        data-testid="order-type"
                                    >
                                        Order Category
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('payment_status')}>
                                    <a
                                        href="#pills-profileVertical "
                                        className={`nav-link block text-base font-semibold ${selectedType === 'payment_status' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-size"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-sizemm"
                                        role="tab"
                                        aria-controls="pills-sizemm"
                                        aria-selected="false"
                                        data-testid="payment-status"
                                    >
                                        Payment Status
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('date_range')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base font-semibold ${selectedType === 'date_range' ? 'active' : ''} text-[#AAA6AF] order relative w-full`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Date Range
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start mb-4 w-full" role="presentation" onClick={() => setselectedType('plant_name')}>
                                    <a
                                        href="#pills-profilemaingroup"
                                        className={`nav-link block text-base ${selectedType === 'plant_name' ? 'active' : ''} font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="product-maingroup"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-profilemaingroup"
                                        role="tab"
                                        aria-controls="pills-profilemaingroup"
                                        aria-selected="false"
                                        data-testid="warehouse"
                                    >
                                        Plant/Warehouse Name
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start mb-4 w-full" role="presentation" onClick={() => setselectedType('customer_code')}>
                                    <a
                                        href="#pills-subgroup"
                                        className={`nav-link block ${selectedType === 'customer_code' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="product-subgroup"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-subgroup"
                                        role="tab"
                                        aria-controls="pills-subgroup"
                                        aria-selected="false"
                                        data-testid="customer-code"
                                    >
                                        Customer Code
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[75%] h-[230px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane fade ${selectedType === 'order_category' ? 'show active' : ''} px-3 max-h-[210px] overflow-auto custom-scrollbar`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {orderTypes.map((order, orderIndex) => (
                                                <div className="flex items-center mb-3" key={`order-${orderIndex}`} onClick={() => HandleFilter('order_category', order)}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes(order) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.order_category?.includes(order)}
                                                        // onChange={() => HandleFilter('order_category', order)}
                                                        borderColor={`${Filter.order_category?.includes(order) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={order}
                                                        // label={order}
                                                    />
                                                    <label data-testid={order} htmlFor={`order-${orderIndex}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {order}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'payment_status' ? 'show active' : ''} fade w-full overflow-auto px-3 h-[190px] sidebar`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="cursor-pointer">
                                        <div className="flex items-center mb-3" onClick={() => HandleFilter('payment_status', 'PENDING')}>
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PENDING') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PENDING')}
                                                // onChange={() => HandleFilter('payment_status', 'PENDING')}
                                                borderColor={`${Filter.payment_status.includes('PENDING') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn4" data-testid="pending" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Pending</label>
                                        </div>
                                        <div className="flex items-center mb-3" onClick={() => HandleFilter('payment_status', 'PARTIAL')}>
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PARTIAL') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PARTIAL')}
                                                // onChange={() => HandleFilter('payment_status', 'PARTIAL')}
                                                borderColor={`${Filter.payment_status.includes('PARTIAL') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn5" data-testid="partial" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Partial</label>
                                        </div>
                                        <div className="flex items-center mb-3" onClick={() => HandleFilter('payment_status', 'PAID')}>
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.payment_status?.includes('PAID') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.payment_status.includes('PAID')}
                                                // onChange={() => HandleFilter('payment_status', 'PAID')}
                                                borderColor={`${Filter.payment_status.includes('PAID') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label htmlFor="mn6" data-testid="paid" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Paid</label>
                                        </div>
                                    </div>
                                </div>
                                <div ref={dateRef} className={`tab-pane fade  px-3 ${selectedType === 'date_range' ? 'show active' : ''}`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.start_date && <Calendar value={moment(selected.start_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'start_date')} placeholder="Date from" />}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && <Calendar value={moment(selected.end_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane  ${selectedType === 'plant_name' ? 'show active' : ''} fade w-full px-3 max-h-[210px] overflow-auto custom-scrollbar`} id="pills-profilemaingroup" role="tabpanel" aria-labelledby="product-maingroup">
                                    {/* <div className="cursor-pointer">
                                        {threeplList.length > 0 && threeplList.map((location) => (
                                            {location.DESCRIPTION !== null &&
                                            <div className="flex items-center mb-3">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.plant_name?.includes(location.ORGANIZATION_ID) ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.plant_name.includes(location.ORGANIZATION_ID)}
                                                    onChange={() => HandleFilter('plant_name', location.ORGANIZATION_ID)}
                                                    borderColor={`${Filter.plant_name.includes(location.ORGANIZATION_ID) ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn10" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{location.DESCRIPTION}</label>
                                            </div>
                                        }
                                        ))}
                                    </div> */}
                                    <div className="cursor-pointer">
                                        {threeplList.length > 0 && threeplList.map((location, i) => (
                                            location?.DESCRIPTION !== null && (
                                                <div className="flex items-center mb-3" key={location.ORGANIZATION_ID} onClick={() => HandleFilter('plant_name', location.ORGANIZATION_ID)}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.plant_name?.includes(location.ORGANIZATION_ID) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.plant_name.includes(location.ORGANIZATION_ID)}
                                                        // onChange={() => HandleFilter('plant_name', location.ORGANIZATION_ID)}
                                                        borderColor={`${Filter.plant_name.includes(location.ORGANIZATION_ID) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                    />
                                                    <label data-testid={location} htmlFor={location.ORGANIZATION_ID} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{location.DESCRIPTION}</label>
                                                </div>
                                            )
                                        ))}
                                    </div>

                                </div>
                                <div className={`tab-pane fade px-3 ${selectedType === 'customer_code' ? 'show active' : ''}`} id="pills-subgroup" role="tabpanel" aria-labelledby="product-subgroup">
                                    <div className="dropdown relative">
                                        <div className=" border rounded-t-[4px] border-[#D8D8D8] bg-[#FFFFFF] text-lg font-normal text-[#090406]">
                                            <input
                                                className="text-sm font-normal h-[30px] w-[298px] outline-none text-[#090406] text-start pl-1 pr-[37px] bg-[#FFFFFF]"
                                                value={searchValue}
                                                placeholder="Search Customer Code"
                                                data-testid="search-customer-code"
                                                onClick={() => setSearchDropdown(!searchDropdown)}
                                                onChange={(e) => {
                                                    { onChangeSearch((e.target.value).trim()); }
                                                }}
                                            />
                                        </div>
                                        {distributorSearchResult && searchDropdown && (
                                            <ul className=" border h-[145px]  overflow-y-auto scrollbar-menu overflow-x-hidden   z-[9999]">
                                                {distributorSearchResult.length > 0 && distributorSearchResult.map((ele, i) => (
                                                    <li className="py-[8px] pl-[10px]">
                                                        <div className="flex items-center " key={`ele-${i}`} onClick={() => HandleFilter('customer_code', ele?.ACCOUNT_NUMBER)}>
                                                            <Checkbox
                                                                icon={
                                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER) ? '#555259' : ''}` }} />
                                                                }
                                                                name="my-input"
                                                                className="cursor-pointer"
                                                                checked={Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER)}
                                                                // onChange={() => HandleFilter('customer_code', ele?.ACCOUNT_NUMBER)}
                                                                borderColor={`${Filter.customer_code?.includes(ele?.ACCOUNT_NUMBER) ? '#B8C5DC' : '#555259'}`}
                                                                style={{ cursor: 'pointer' }}
                                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                            />
                                                            <label htmlFor={`ele-${i}`} data-testid={`customer-code-${i}`} className="consumbales pl-3 text-sm46 font-normal text-[#090406] text-left cursor-pointer">{ele.ACCOUNT_NUMBER}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[40%] mr-4">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    data-testid="apply-btn"
                                    onClick={() => generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
